import styles from './StepsHeader.module.css'
import React from "react";

interface StepsHeaderProps {
    title: string;
    text: string;
}

export const StepsHeader:React.FC<StepsHeaderProps> = ({title,text}) => (
    <div className={styles.container}>
        <p className={styles.title}>{title}</p>
        <p className={styles.slash}>/</p>
        <p className={styles.text}>{text}</p>
    </div>
);